export enum DAC_MESSAGING_IDS {
    METHOD_GET_ENV_INFO = 'getEnviromentInfo',
    METHOD_GET_PUB_WIDGETS = 'getPublishedWidgets',
    METHOD_GET_PUB_WIDGET = 'getPublishedWidget',
    METHOD_INSTALL_WIDGET = 'installWidget',
    METHOD_UPGRADE_WIDGET = 'upgradeWidget',
}